import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ChatbotService {
  domain = '';
  browser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: string) {
    this.browser = isPlatformBrowser(platformId);
    if (this.browser) {
      this.domain = this.getDomain();
    }
  }

  getDomain(): string {
    let dom = '';
    if (this.browser) {
      const domArray = window.location.hostname.split('.');
      if (domArray.length >= 2) {
        dom = domArray[domArray.length - 2] + '.' + domArray[domArray.length - 1];
      } else {
        dom = domArray[0];
      }
    }
    return dom;
  }

  setCookie(cookieName: string, cookieValue: string): void {
    if (this.browser) {
      document.cookie = cookieName + '=' + cookieValue + '; path=/; domain=' + this.domain + ';';
    }
  }

  deleteCookie(cookieName: string): void {
    if (this.browser) {
      document.cookie = cookieName + '=; path=/; domain=' + this.domain + '; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
    }
  }

  getCookie(cname: any): string {
    const name = cname + '=';
    if (this.browser) {
      const decodedCookie = decodeURIComponent(document.cookie);
      const ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
    }
    return '';
  }

  clearAllCookies(): void {
    this.deleteCookie('chatBotSessionId');
    this.deleteCookie('chatBotOASUserName');
    this.deleteCookie('chatBotOASAccountId');
  }
}
